import type { RegisterOptions } from "react-hook-form";
import { useController, useFormContext } from "react-hook-form";
import { FormControl } from "@mui/material";
import { useTranslations } from "next-intl";
import { ScaleButtonGroup } from "../common";
import { getValidationRules } from "./utils/getValidationRules";
import { HelperMessage } from "./HelperMessage";

interface FormScaleButtonGroupProps {
  className?: string;
  name: string;
  label?: string;
  required?: boolean;
  rules?: RegisterOptions;
  min?: number;
  max?: number;
  scaleLabels?: Record<number, string>;
  showError?: boolean;
  onChange?: (value: string) => void;
}

export const FormScaleButtonGroup: React.FC<FormScaleButtonGroupProps> = ({
  className,
  name,
  required = true,
  rules = {},
  showError = true,
  onChange = () => null,
  ...rest
}) => {
  const t = useTranslations();
  const validationRules = getValidationRules({
    required,
    rules,
    t,
  });

  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext();

  const {
    field: { value },
  } = useController({
    name,
    rules: validationRules,
    control,
  });

  const handleChange = (newValue: string) => {
    setValue(name, newValue);
    onChange(newValue);
  };

  return (
    <FormControl className={className ?? "body-l flex flex-1 flex-col"}>
      <ScaleButtonGroup
        name={name}
        onChange={handleChange}
        value={value as string}
        {...rest}
      />
      <HelperMessage errors={errors} name={name} showError={showError} />
    </FormControl>
  );
};
